module.exports = __webpack_public_path__ + "static/img/艺术摆件1.785aa99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/艺术摆件1.jpg
// module id = AkGm
// module chunks = 1